import axios from 'axios'
import UrlConstant from '../common/url-constant'

const baseServerAxios = axios.create({
  baseURL: UrlConstant.api.ROOT,
  withCredentials: true
})

export default baseServerAxios



// WEBPACK FOOTER //
// ./src/services/axios-instance-provider.js